// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".languageSelector[data-v-0dee5a99]{padding-bottom:2.4rem;padding-top:.6rem}#systime-ibog .v-btn--lang-switcher[data-v-0dee5a99]:focus:before,#systime-ibog .v-btn--lang-switcher[data-v-0dee5a99]:hover:before{opacity:.1}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
module.exports = ___CSS_LOADER_EXPORT___;
